// 2020-08-04 00:00:00 
// var end = '2020-08-04 23:59:59';

class Countdown{

    getNowTimestamp(timeZone) {
        // return timeStampe 
        var timezone = timeZone || 8; 
        var offset_GMT = new Date().getTimezoneOffset(); 
        var nowDate = new Date().getTime(); 
        var targetDate = nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000;
        return targetDate;
    }

    getTimeRemaining() {
        let now_time = this.time_now;
        console.log(this.end_time,this.getNowTimestamp());
        var t = this.deadline - this.getNowTimestamp();
        console.log('left time:',t);
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
          'total': t,
          'days': days,
          'hours': hours,
          'minutes': minutes,
          'seconds': seconds
        };
      }

      initClock(id, endtime) {
      //   var clock = document.getElementById(id);
      //   var daysSpan = clock.querySelector('.day');
      //   var hoursSpan = clock.querySelector('.hour');
      //   var minutesSpan = clock.querySelector('.minute');
      //   var secondsSpan = clock.querySelector('.seconds');
        var that   = this  ;
        function updateClock() {
          var t = that.getTimeRemaining(endtime);
          // console.log('left time',t.total );
          if (t.total <= 0 || isNaN(t.total)) {
            clearInterval(timeinterval);
            $(that.container).hide();
            if(that.container === 'top_notice'){
                  $("#top_notice").show();  
            }
            return;

          }else{
            $("#top_notice").hide(); 
          }
          // daysSpan.innerHTML = t.days + "<i>days</i>";
          $("#"+id + " .day").html(t.days + "<i>days</i>");
          // hoursSpan.innerHTML = ('0' + t.hours).slice(-2) + "<i>hours</i>";
          $("#"+id + " .hour").html(('0' + t.hours).slice(-2) + "<i>hours</i>");
          // minutesSpan.innerHTML = ('0' + t.minutes).slice(-2) + "<i>minutes</i>";
          $("#"+id + " .minute").html(('0' + t.minutes).slice(-2) + "<i>minutes</i>");
          // secondsSpan.innerHTML = ('0' + t.seconds).slice(-2) + "<i>seconds</i>";
          $("#"+id + " .seconds").html(('0' + t.seconds).slice(-2) + "<i>seconds</i>");

        }

        updateClock();
        var timeinterval = setInterval(updateClock, 1000);
      }


      constructor(start_time,end_time,time_now,  container,timediv  ){
        var start_time = Date.parse(start_time);
        var deadline = new Date(Date.parse(end_time));
        var  now_time = Date.parse(time_now);
        this.start_time = start_time;
        this.deadline = deadline;
        this.now_time = now_time;
        this.container = container;
        this.timediv = timediv;
      }

      init(){
        if(this.now_time < this.start_time || this.now_time > this.deadline ){
               console.log('flash sale not begin');
               $(this.container).hide();
            }else{
              console.log('#flash sale  begin',this.container);
             // console.log(jQuery().jquery);  
              $(this.container+"").show();
              this.initClock(this.timediv, this.deadline);
            }

      }
}

// flash sale at prouct 


        $(function(){
            var start_time = $('#time_container').data('start_time');
            var end = $('#time_container').data('end_time');
            var time_now =  $('#time_container').data('time_now');
            var container = '#flash_sale_container';
            var timediv = 'clockdiv';
            var countdown = new Countdown(start_time,end,time_now,container,timediv);
            countdown.init();
        })




// flash sale at top 
$(function(){
    var start_time = $('#falsh_sale_top_meta').data('start_time');
    var end = $('#falsh_sale_top_meta').data('end_time');
    var time_now =  $('#falsh_sale_top_meta').data('time_now');
    var container = '#flash_sale_top';
    var timediv = 'sale_top';
    var countdown = new Countdown(start_time,end,time_now,container,timediv);
    countdown.init();
})